var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolluscs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32693 10.75C8.32693 13.25 10.2499 16.75 14.29 16.75C18.33 16.75 20.75 13.616 20.75 9.75C20.75 4.78 16.52 0.75 10.8119 0.75C5.16492 0.75 0.162888 5.005 0.805892 12.137C0.820369 12.3206 0.89143 12.4951 1.00928 12.6366C1.12713 12.7781 1.28597 12.8796 1.4639 12.927C4.16391 13.609 6.93793 12.614 8.32693 10.75ZM8.32693 10.75C8.32693 5.622 16.277 4.541 16.277 9.75C16.277 11.219 15.25 12.476 13.793 12.996",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolluscs);
export default __webpack_public_path__ + "static/media/molluscs.6428deb75462c102d27647d288910a81.svg";
export { ForwardRef as ReactComponent };